var exports = {
  "kL": "EmojiTooltipContent.module__container___LVVwVj",
  "Zg": "EmojiTooltipContent.module__emoji___LVVwVj",
  "FS": "EmojiTooltipContent.module__textContainer___LVVwVj",
  "Lq": "EmojiTooltipContent.module__loading___LVVwVj",
  "W$": "EmojiTooltipContent.module__subtext___LVVwVj",
  "vW": "EmojiTooltipContent.module__inner___LVVwVj",
};

module.exports = exports;
